module.exports = __webpack_public_path__ + "img/avatar-2.b767e4ba.jpg";